import { CRM_OBJECT_UPSERT } from '../../constants/Tools';
import { parseObjectId } from '../../utils/parserUtils';
import { getChirpToolOrLegacyTool } from '../utils/chirpToolUtil';

/**
 * Converts a legacy Object Update action to a V2 compatible format
 * @param inAppActionLegacy The legacy action to convert
 * @returns The converted action in V2 format
 */
export const convertCrmObjectUpsertAction = (inAppActionLegacy, isUngatedForLoadableTools) => {
  const {
    name,
    chirpToolServiceFqcn
  } = getChirpToolOrLegacyTool(CRM_OBJECT_UPSERT, isUngatedForLoadableTools);
  return {
    name,
    chirpToolServiceFqcn,
    arguments: {
      '@type': 'map',
      value: {
        // TODO - investigate handling associated_object without the data from legacy action
        // TODO - investigate handling is_marketing_task without the data from legacy action
        // TODO - investigate handling object_query without the data from legacy action
        objects: {
          '@type': 'list',
          value: [{
            '@type': 'map',
            value: {
              objectId: {
                '@type': 'long',
                value: Number(parseObjectId(inAppActionLegacy.objectId))
              },
              objectTypeId: {
                '@type': 'string',
                value: inAppActionLegacy.objectTypeId
              }
            }
          }]
        },
        operation: {
          '@type': 'string',
          value: 'update' // TODO - this is hard-coded since there is no operation in legacy action
        },
        object_type: {
          '@type': 'string',
          value: inAppActionLegacy.objectTypeId
        },
        properties: {
          '@type': 'map',
          value: Object.entries(inAppActionLegacy.properties).reduce((acc, [key, value]) => {
            if (typeof value === 'string') {
              acc[key] = {
                '@type': 'string',
                value
              };
            } else {
              acc[key] = {
                '@type': 'integer',
                value
              };
            }
            return acc;
          }, {})
        }
      }
    }
  };
};